import UpcomingEventWrapper from './UpcomingEventWrapper';

export default UpcomingEventWrapper;
